import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["summaryTextareaWrapper"];
  static values = { view: String };

  summaryTextareaWrapperTargetConnected(wrapper) {
    const input = wrapper.querySelector("textarea");
    if (!input) return;

    input.maxLength = 256;

    const counter = document.createElement("span");
    counter.classList.add("text-sm", "text-gray-500", "mt-1", "block");
    input.insertAdjacentElement("afterend", counter);

    const update = () => {
      const remaining = input.maxLength - input.value.length;
      counter.textContent = `${remaining} / ${input.maxLength} Zeichen übrig`;
    };

    update();
    input.addEventListener("input", update);
  }
}
